<template>
  <v-card class="mt-4 user-info-card" flat>
    <v-card-text class="pa-4">
      <div class="d-flex justify-space-between align-center flex-wrap">
        <div class="d-flex align-center">
          <v-avatar color="#f36f21" size="56" class="mr-4">
            <v-icon color="white" size="28">mdi-account</v-icon>
          </v-avatar>
          <div>
            <div class="user-name">
              {{ partnerInfo?.fullname }}
            </div>
            <div class="user-id"># {{ partnerInfo?.uniqueReferralCode }}</div>
          </div>
        </div>
        <div class="d-flex align-center flex-column flex-md-row contact-info">
          <div class="d-flex align-center mr-md-4 mb-2 mb-md-0">
            <v-icon color="#f36f21" size="20" class="mr-2">mdi-email</v-icon>
            <span class="contact-text">{{
              partnerInfo?.emailId || "connect@mudra-mitra.com"
            }}</span>
          </div>
          <div class="d-flex align-center">
            <v-icon color="#f36f21" size="20" class="mr-2">mdi-phone</v-icon>
            <span class="contact-text">{{ formattedPhone }}</span>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import * as Data from "@/../src-gen/data";

@Component({
  components: {},
})
export default class FPPSalesDashboardUserInfo extends Vue {
  @Prop()
  partnerInfo: Data.Partner.PartnerSummary;

  get formattedPhone() {
    if (this.partnerInfo?.mobile) {
      // Format phone number as XXXXX XXXXX (same as phone filter)
      const phone = this.partnerInfo.mobile.toString().replace(/\D/g, "");
      if (phone.length === 10) {
        return `${phone.substring(0, 5)} ${phone.substring(5, 10)}`;
      }
      return this.partnerInfo.mobile;
    }
    return "89800 44094";
  }
}
</script>

<style lang="scss" scoped>
.user-info-card {
  background: #ffffff;
  border-radius: 8px;
  // box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

  .user-name {
    font-size: 18px;
    font-weight: bold;
    color: #00447a;
    margin-bottom: 4px;
  }

  .user-id {
    font-size: 14px;
    color: #666;
  }

  .contact-info .contact-text {
    font-size: 14px;
    color: #333;
  }
}
</style>
